// src/components/CustomerForm.js

import React, { useState, forwardRef, useEffect,useImperativeHandle  } from 'react';
import {Modal} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import axios from "axios";
 import {useNavigate, useParams} from "react-router-dom";
 import { ToastContainer, toast } from "react-toastify";
 import "react-toastify/dist/ReactToastify.css";
 
  
 const InviteCustomer = forwardRef((props, ref) => {
  const [inviteModal , setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
      showInviteModal() {
 
          setInviteModal(true)
      }
  
    }))  
  // Form state
   const [formData, setFormData] = useState({
     FirstName: '',
     LastName: '',
     Phone: '',
     Email: '',
     Address: '',
     DateOfBirth: '',
     Occupation: '',
     Photo: '',
     Workplace: '',
     WorkplaceAddress: '',
     Notes: '',
     Status: '',
   });
   const notifyTopRight = () => {
    toast.success("✔️ تمت عملية الحفظ بنجاح", {
      position: "top-right",
      autoClose: 800,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
    });
  }; 
   const [errors, setErrors] = useState(null); // Handling errors
 
   // Handle form field change
   const handleChange = (e) => {
     const { name, value } = e.target;
     setFormData({
       ...formData,
       [name]: value,
     });
   };
 
   // Handle form submit
   const handleSubmit = async (e) => {
     e.preventDefault();
     if (!formData.Phone || !formData.Phone.match(/^(218)?09[123456][0-9]{7}$/))
        {
    
setErrors('رقم الهاتف  : 00 00 000 091 او 00 00 000 092')
console.log(errors)
    }
else{
     try {
       // Send POST request to the API
       const response = await axios.post('https://subk.education.com.ly/back/api/customers', formData);
       notifyTopRight();
       console.log('Response:', response.data);
       props.parentFunction()
       setInviteModal(false); // Close modal on success
     } catch (error) {
       console.error('There was an error submitting the form!', error);
       setErrors('Failed to submit customer data.');
     }
    } };
 
   return (
    <>
    <ToastContainer />

     <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
       <div className="modal-content">
         <div className="modal-header">
           <h1 className="modal-title fs-5" id="exampleModalLabel1">بيانات الزبون</h1>
           <button
             type="button"
             className="btn-close"
             style={{ marginLeft: 0 }}
             onClick={() => setInviteModal(false)}
           ></button>
         </div>
 
         <form onSubmit={handleSubmit}>
           <div className="modal-body">
             <div className="row">
               <div className="col-xl-12">
                 {errors && <div className="alert alert-danger">{errors}</div>}
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">الاسم <span className="text-danger">*</span></label>
                 <input
                   className="form-control"
                   type="text"
                   name="FirstName"
                   value={formData.FirstName}
                   onChange={handleChange}
                   required
                     pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">اللقب<span className="text-danger">*</span></label>
                 <input
                   className="form-control"
                   type="text"
                   name="LastName"
                   value={formData.LastName}
                   onChange={handleChange}
                   required
                      pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">رقم الهاتف</label>
                 <input
                   className="form-control"
                   type="text"
                   name="Phone"
                   value={formData.Phone}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">البريد الالكتروني<span className="text-danger">*</span></label>
                 <input
                   className="form-control"
                   type="email"
                   name="Email"
                   value={formData.Email}
                   onChange={handleChange}
                  />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">العنوان</label>
                 <input
                   className="form-control"
                   type="text"
                   name="Address"
                   value={formData.Address}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">تاريخ الميلاد</label>
                 <input
                   className="form-control"
                   type="date"
                   name="DateOfBirth"
                   value={formData.DateOfBirth}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">المهنة</label>
                 <input
                   className="form-control"
                   type="text"
                   name="Occupation"
                   value={formData.Occupation}
                   onChange={handleChange}
                     pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                 />
               </div>
 
                
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">مكان العمل</label>
                 <input
                   className="form-control"
                   type="text"
                   name="Workplace"
                   value={formData.Workplace}
                   onChange={handleChange}
                     pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                            title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">عنوان مكان العمل</label>
                 <input
                   className="form-control"
                   type="text"
                   name="WorkplaceAddress"
                   value={formData.WorkplaceAddress}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">ملاحظات</label>
                 <textarea
                   className="form-control"
                   name="Notes"
                   value={formData.Notes}
                   onChange={handleChange}
                 />
               </div>
 
               
             </div>
           </div>
 
           <div className="modal-footer">
             <button type="submit" className="btn btn-primary">حفظ</button>
             <button
               type="button"
               className="btn btn-danger light"
               onClick={() => setInviteModal(false)}
             >
               الغاء
             </button>
           </div>
         </form>
       </div>
     </Modal>
     </>
   );
 }
 
)
export default InviteCustomer;
